export enum SegmentType {
  Weather = "weather",
  Events = "events",
  News = "news",
}
